function loadCSV() {
  const csvUrl = document.getElementById("csvUrl").value;

  fetch(csvUrl)
    .then((response) => response.text())
    .then((csvText) => {
      const rows = csvText
        .split("\n")
        .map(row => row.trim()) // Trim each row
        .filter(row => row !== "") // Filter out empty rows
        .slice(1); // Skip header row
      csvData = rows;
      const brands = new Set();

      // Populate Brand Dropdown
      const chooseOption = document.createElement("option");//simon
      chooseOption.value = "choose";//simon
      chooseOption.text = "Select your usual foundation";//simon
      const brandDropdown = document.getElementById("brandDropdown");
      brandDropdown.add(chooseOption);//simon
      rows.forEach((row) => {
        const [brand, , ,] = row.split(",");
        brands.add(brand);
      });

      brands.forEach((brand) => {
        const option = document.createElement("option");
        option.value = brand;
        option.text = brand;
        brandDropdown.add(option);
      });

      // Update subsequent dropdowns
      brandDropdown.addEventListener("change", () => {
        updateProductDropdown(rows);
      });
    })
    .catch((error) => console.error("Error loading CSV:", error));

}

function updateProductDropdown(rows) {
  const chooseOption = document.createElement("option");//simon
    chooseOption.value = "choose";//simon
    chooseOption.text = "Select your collection";//simon
  const productDropdown = document.getElementById("productDropdown");
  productDropdown.innerHTML = "";
  productDropdown.add(chooseOption);//simon
  const selectedBrand = brandDropdown.value;
  const filteredProducts = rows.filter((row) => row.startsWith(selectedBrand));
  const products = new Set();

  filteredProducts.forEach((row) => {
    const [, product, ,] = row.split(",");
    products.add(product);
  });

  products.forEach((product) => {
    const option = document.createElement("option");
    option.value = product;
    option.text = product;
    productDropdown.add(option);
  });
  productDropdown.addEventListener("change", () => {
    updateShadeDropdown(rows);
    document.getElementById('shade-foundation').classList.remove('initially-hidden');
  });

}

function updateShadeDropdown(rows) {
  const chooseOption = document.createElement("option");//simon
  chooseOption.value = "choose";//simon
  chooseOption.text = "What shade do you use?";//simon
  const shadeDropdown = document.getElementById("shade-foundation");
  shadeDropdown.innerHTML = ""; // Clear previous options
  shadeDropdown.add(chooseOption);//simon
  const selectedBrand = brandDropdown.value;
  const selectedProduct = productDropdown.value;

  const filteredShades = rows.filter((row) =>
    row.startsWith(`${selectedBrand},${selectedProduct}`)
  );
  const descriptions = new Set();

  filteredShades.forEach((row) => {
    const [, , description] = row.split(",");
    descriptions.add(description);
  });

  descriptions.forEach((description) => {
    const option = document.createElement("option");
    option.value = description;
    option.text = description;
    shadeDropdown.add(option);
  });
  shadeDropdown.addEventListener("change", () => {
    document.getElementById('displayOutputBtn').classList.remove('initially-hidden');
  });
  
}

async function displayOutput(rows) {
    const output = document.getElementById("output");
    output.innerHTML = ""; 
  
    const brand = document.getElementById("brandDropdown").value;
    const product = document.getElementById("productDropdown").value;
    const shade = document.getElementById("shade-foundation").value;
  
    // Find the matching row 
    const matchingRow = rows.find((row) =>
      row.startsWith(`${brand},${product},${shade}`)
    );
    console.log('displayOutput function started'); // Check if function runs
    // ... rest of your code ...

    if (matchingRow) {
      const [_, __, ___, lowestValue, variantId] = matchingRow.split(",");
      const row = document.createElement("div");
      row.classList.add("result-row");
  
      const variantIdInt = parseInt(variantId, 10);
      const productHandle = document.getElementById('productHandle').value;
      const variantDetailsUrl = `/products/${productHandle}.js`;
      const response = await fetch(variantDetailsUrl);
      const productData = await response.json();
  
      const selectedVariant = productData.variants.find(variant => variant.id === variantIdInt);
  
      if (selectedVariant && selectedVariant.featured_image) {
        output.innerHTML = `
          <div class="result-row">
            <div class="shade-name">${lowestValue}</div>
            <img class="image-shade" src="${selectedVariant.featured_image.src}" alt="${selectedVariant.featured_image.alt}" /> 
            <div class="product-cta-container">
              <form method="post" action="/cart/add">
                <input type="hidden" name="id" value="${variantIdInt}">
                <input  type="hidden"  type="number" id="quantity" name="quantity" value="1" />
                <input type="submit" value="Add to cart" class="product-cta button button-purchase" />
              </form>
            </div>
          </div>
        `;
      } else {
        output.innerHTML = "<p>Error: Variant not found or no image available.</p>";
      }
  
       
    } else {
        console.log('No matching row found');
     }
  }
  
  
  document.addEventListener('DOMContentLoaded', function() { 
    loadCSV(); // Initialize 

    const displayBtn = document.getElementById('displayOutputBtn');
    displayBtn.addEventListener('click', () => displayOutput(csvData)); 
});

//SIMON CODE

  const brandinput = document.getElementById("brandDropdown");
  const productinput = document.getElementById("productDropdown");
  brandinput.addEventListener("change", updateShadeDropdown);
  productinput.addEventListener("change", updateShadeDropdown);

